/**
 * Tarix formatları.
 *
 * Brauzerlər `az-AZ` dilini tam dəstəkləmir: `month: 'short'` istəyəndə
 * "okt" əvəzinə "M10", `weekday: 'long'` istəyəndə "Fri" qaytarır.
 * Ona görə Azərbaycan dili üçün adları özümüz veririk, ingilis dilində isə
 * brauzerin öz formatı işlədilir (orada problem yoxdur).
 */

const AZ_MONTH_SHORT = ['yan', 'fev', 'mar', 'apr', 'may', 'iyn', 'iyl', 'avq', 'sen', 'okt', 'noy', 'dek'];
const AZ_MONTH_LONG  = ['yanvar', 'fevral', 'mart', 'aprel', 'may', 'iyun',
                        'iyul', 'avqust', 'sentyabr', 'oktyabr', 'noyabr', 'dekabr'];
const AZ_WEEKDAY     = ['bazar', 'bazar ertəsi', 'çərşənbə axşamı', 'çərşənbə',
                        'cümə axşamı', 'cümə', 'şənbə'];

const pad = n => String(n).padStart(2, '0');
const toDate = d => {
  if (!d) return null;
  const dt = d instanceof Date ? d : new Date(d);
  return isNaN(dt.getTime()) ? null : dt;
};
const hhmm = dt => `${pad(dt.getHours())}:${pad(dt.getMinutes())}`;

/** 16.10.2026 */
export function fmtDate(d, lang) {
  const dt = toDate(d); if (!dt) return '—';
  if (lang === 'en') return dt.toLocaleDateString('en-GB');
  return `${pad(dt.getDate())}.${pad(dt.getMonth() + 1)}.${dt.getFullYear()}`;
}

/** 16.10.2026 14:30 */
export function fmtDateTime(d, lang) {
  const dt = toDate(d); if (!dt) return '—';
  return `${fmtDate(dt, lang)} ${hhmm(dt)}`;
}

/** 16 okt */
export function fmtShort(d, lang) {
  const dt = toDate(d); if (!dt) return '';
  if (lang === 'en') return dt.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
  return `${pad(dt.getDate())} ${AZ_MONTH_SHORT[dt.getMonth()]}`;
}

/** 16 okt 14:30 */
export function fmtShortTime(d, lang) {
  const dt = toDate(d); if (!dt) return '';
  return `${fmtShort(dt, lang)} ${hhmm(dt)}`;
}

/** 16 oktyabr 2026 */
export function fmtLong(d, lang) {
  const dt = toDate(d); if (!dt) return '—';
  if (lang === 'en') return dt.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
  return `${dt.getDate()} ${AZ_MONTH_LONG[dt.getMonth()]} ${dt.getFullYear()}`;
}

/** cümə, 16 oktyabr 2026 */
export function fmtFull(d, lang) {
  const dt = toDate(d); if (!dt) return '—';
  if (lang === 'en') {
    return dt.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
  }
  return `${AZ_WEEKDAY[dt.getDay()]}, ${fmtLong(dt, lang)}`;
}

/** cümə */
export function fmtWeekday(d, lang) {
  const dt = toDate(d); if (!dt) return '';
  if (lang === 'en') return dt.toLocaleDateString('en-GB', { weekday: 'long' });
  return AZ_WEEKDAY[dt.getDay()];
}

/** oktyabr 2026 */
export function fmtMonthYear(d, lang) {
  const dt = toDate(d); if (!dt) return '—';
  if (lang === 'en') return dt.toLocaleDateString('en-GB', { month: 'long', year: 'numeric' });
  return `${AZ_MONTH_LONG[dt.getMonth()]} ${dt.getFullYear()}`;
}

/** 14:30 */
export function fmtTime(d) {
  const dt = toDate(d); if (!dt) return '';
  return hhmm(dt);
}

/** İşburaxma vaxtı QURŞAQSIZ saxlanılır: forma "2026-10-23T16:30" göndərir,
 *  bazada da elə 16:30 durur — işçinin yazdığı divar saatıdır.
 *  Server onu UTC kimi işarələyib qaytarır ("...T16:30:00.000Z"), ona görə
 *  burada qurşaq çevrilməsi EDİLMİR: UTC komponentləri oxunur və saxlanan
 *  saat olduğu kimi göstərilir. Əks halda Bakıda (+4) 16:30 -> 20:30 olurdu.
 *
 *  Eyni gün:   23 oktyabr 2026, 16:30 – 17:00
 *  Fərqli gün: 16 noyabr 2026, 08:00 → 20 noyabr 2026, 16:30
 *  Bütün gün:  yalnız tarix
 */
function wallParts(d) {
  const dt = toDate(d); if (!dt) return null;
  return {
    day: dt.getUTCDate(), month: dt.getUTCMonth(), year: dt.getUTCFullYear(),
    hm: String(dt.getUTCHours()).padStart(2, '0') + ':' +
        String(dt.getUTCMinutes()).padStart(2, '0'),
  };
}
function wallDate(p, lang) {
  if (lang === 'en') {
    const EN = ['January','February','March','April','May','June',
                'July','August','September','October','November','December'];
    return `${p.day} ${EN[p.month]} ${p.year}`;
  }
  return `${p.day} ${AZ_MONTH_LONG[p.month]} ${p.year}`;
}
export function fmtRange(start, end, lang) {
  const a = wallParts(start); if (!a) return '—';
  const b = wallParts(end);
  const aD = wallDate(a, lang);
  if (!b) return `${aD}, ${a.hm}`;
  const bD = wallDate(b, lang);
  const sameDay = aD === bD;
  const allDay = a.hm === '00:00' && (b.hm === '00:00' || b.hm === '23:59');
  if (allDay) return sameDay ? aD : `${aD} → ${bD}`;
  if (sameDay) return `${aD}, ${a.hm} – ${b.hm}`;
  return `${aD}, ${a.hm} → ${bD}, ${b.hm}`;
}
